import { useQuery } from "@tanstack/react-query";

import { apiClient } from "../../lib/apiClient";
import { ApiRequestError } from "../../lib/errors";
import { queryKeys } from "../../lib/queryKeys";

export function useTranscriptVariables(transcriptId: string, enabled: boolean) {
  return useQuery({
    queryKey: queryKeys.transcripts.variables(transcriptId),
    enabled,
    staleTime: Number.POSITIVE_INFINITY,
    queryFn: async () => {
      const { data, error } = await apiClient.GET(
        "/v1/transcripts/{id}/variables",
        { params: { path: { id: transcriptId } } },
      );
      if (error) {
        throw new ApiRequestError(error);
      }
      return data;
    },
  });
}
